// EXIF read via exifr (MIT): orientation, capture date, artist, copyright, GPS presence.
import * as exifr from 'exifr';
import type { ExifSummary } from './decode/types';

export async function readExif(data: Blob | ArrayBuffer | Uint8Array): Promise<ExifSummary> {
  try {
    const t = (await exifr.parse(data, {
      pick: [
        'Orientation',
        'DateTimeOriginal',
        'CreateDate',
        'Artist',
        'Copyright',
        'GPSLatitude',
        'GPSLongitude',
      ],
      translateValues: false,
      reviveValues: true,
      gps: true,
    })) as Record<string, unknown> | undefined;
    if (!t) return { orientation: 1, hasGps: false };
    const d = (t.DateTimeOriginal ?? t.CreateDate) as Date | string | undefined;
    const date = d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString().slice(0, 10) : undefined;
    const orientation =
      typeof t.Orientation === 'number' && t.Orientation >= 1 && t.Orientation <= 8 ? t.Orientation : 1;
    return {
      orientation,
      date,
      artist: typeof t.Artist === 'string' ? t.Artist : undefined,
      copyright: typeof t.Copyright === 'string' ? t.Copyright : undefined,
      hasGps: t.GPSLatitude !== undefined || t.GPSLongitude !== undefined || t.latitude !== undefined,
    };
  } catch {
    return { orientation: 1, hasGps: false };
  }
}
